<template>
  <div>
    <Multiselect
      class="multiselector-roles"
      v-model="value"
      mode="tags"
      :close-on-select="false"
      :searchable="true"
      :options="options"
      :loading="loading"
    />
  </div>
</template>

<script>
import Multiselect from '@vueform/multiselect';

export default {
  props: ['modelValue'],
  emits: ['onChange'],
  components: {
    Multiselect
  },
  watch: {
    modelValue() {
      this.value = this.modelValue;
    },
    value() {
      this.$emit('onChange', this.value);
    }
  },
  mounted() {
    this.getOptions();
  },
  methods: {
    getOptions() {
      this.options = this.$consts.userRoles.map((b) => {
        return { value: b.key, label: b.name };
      });
    }
  },
  data() {
    return {
      loading: false,
      value: null,
      options: []
    };
  }
};
</script>

<style scoped>
.multiselector-roles {
  border: 1px solid #e2e5e8 !important;
  border-radius: 0.75rem !important;
}
</style>

<style src="@vueform/multiselect/themes/default.css"></style>
